import groupBy from "lodash/fp/groupBy";
import toPairs from "lodash/fp/toPairs";
import sortBy from "lodash/fp/sortBy";
import first from "lodash/fp/first";
import last from "lodash/fp/last";
import map from "lodash/fp/map";
import pipe from "lodash/fp/pipe";

export interface OpeningHour {
  day: number;
  open: string;
  close: string;
}

export interface StructuredOpeningHours {
  day: string;
  times: OpeningHour[];
}

const sortFunction = ({ open }) => {
  const [hours, minutes] = open.split(":");

  return hours;
};

const transformHours = hours => ({
  day: first(hours),
  times: sortBy(sortFunction)(last(hours)),
});

const prepareOpeningHours = (
  openingHours: OpeningHour[]
): StructuredOpeningHours[] => {
  return pipe(
    groupBy("day"),
    toPairs,
    sortBy(first),
    map(transformHours)
  )(openingHours);
};

export { prepareOpeningHours };
